import { render, staticRenderFns } from "./RecipientsSms.vue?vue&type=template&id=f235f294&scoped=true"
import script from "./RecipientsSms.vue?vue&type=script&lang=js"
export * from "./RecipientsSms.vue?vue&type=script&lang=js"
import style0 from "./RecipientsSms.vue?vue&type=style&index=0&id=f235f294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f235f294",
  null
  
)

export default component.exports